<template>
	<div style="background: #F6F6F6;padding-bottom: 50px;position: relative;">
		<div class="wrap">
			<div class="left">
				<div class="left-top-user" id="step1">
					<div class="toux">
						<div @click="$router.push('/userCenter')" style="cursor: pointer;">
							<img :src='getImgSrc($store.state.userInfo.avatar)' alt="">
						</div>
					</div>
					<p style="margin-top: 15px;text-align: center;">{{$store.state.userInfo.nickname}}，欢迎您！</p>
					<div class="qiehuan" style="margin-top: 6px;" @click=" qiehuanDialogVisible = true">
						切换为企业管理
					</div>
					<div class="qiehuan" style="margin-top: 2px;color: orange;" @click=" qiehuanDialogVisible1 = true">
						切换为小组管理
					</div>
					<el-dialog :lock-scroll='false' title="请选择企业" :visible.sync="qiehuanDialogVisible" width="500px"
						center>
						<div class="company">
							<el-select v-model="companiesValue" placeholder="请选择">
								<el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="qiehuanDialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="changeRole">确 定</el-button>
						</span>
					</el-dialog>
					<el-dialog :lock-scroll='false' title="请选择小组" :visible.sync="qiehuanDialogVisible1" width="500px"
						center>
						<div class="company">
							<el-select v-model="companiesValue1" placeholder="请选择">
								<el-option v-for="item in companies1" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="qiehuanDialogVisible1 = false">取 消</el-button>
							<el-button type="primary" @click="changeRole1">确 定</el-button>
						</span>
					</el-dialog>
				</div>
				<div class="body-left">
					<div class="body-left-item">
						<el-collapse v-model="activeNames" @change="handleChange" class="collapse">
							<el-collapse-item name="1">
								<template slot="title">
									<img src='../../assets/images/perinfo .png' style="width: 19px;height: 19px;"
										alt=""><span style="margin-left: 8px;">个人数据</span>
								</template>
								<div class="collapse-inner">
									<p @click="goto(`/userCenter/Resume`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										个人简历
									</p>
									<p @click="goto(`/userCenter/pthd/royalProperty`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										资质荣誉
									</p>
								</div>

							</el-collapse-item>
							<el-collapse-item name="2">
								<template slot="title">
									<img src='../../assets/images/flyicon.png' style="width: 19px;height: 19px;"
										alt=""><span style="margin-left: 8px;">平台活动</span>
								</template>
								<div class="collapse-inner">
									<p @click="goto(`/userCenter/pthd/projectNeed`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										项目需求
									</p>
									<p @click="goto(`/userCenter/pthd/ktdw`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										课题定位
									</p>
									<p @click="goto(`/userCenter/pthd/resourceTools`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										资源工具
									</p>
									<p @click="goto(`/userCenter/pthd/solution`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										解决方案
									</p>
									<p @click="goto(`/userCenter/pthd/productService`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										产品服务
									</p>
									<p @click="goto(`/userCenter/pthd/seekHelp`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
										求助应助
									</p>
								</div>

							</el-collapse-item>
							<el-collapse-item name="3">
								<template slot="title">
									<img src='../../assets/images/xiaoxi.png' style="width: 20px;height: 18px;"
										alt=""><span style="margin-left: 8px;">消息</span>
								</template>
								<div class="collapse-inner">
									<div @click="goto(`/userCenter/pthd/myMessage?type=${2}`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;display: flex;align-items: center;justify-content: space-between;">
										站内信
										<div v-if="$store.state.notReadMsg.message"
											style="background: red;width:15px;height: 15px;border-radius: 50%;color: #fff;text-align: center;line-height: 15px;font-size: 13px;">
											{{$store.state.notReadMsg.message}}</div>
									</div>
									<div @click="goto(`/userCenter/pthd/myMessage?type=${1}`)" class="leftfont"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;display: flex;align-items: center;justify-content: space-between;">
										系统消息
										<div v-if="$store.state.notReadMsg.system_notice"
											style="background: red;width:15px;height: 15px;border-radius: 50%;color: #fff;text-align: center;line-height: 15px;font-size: 13px;">
											{{$store.state.notReadMsg.system_notice}}</div>
									</div>

								</div>

							</el-collapse-item>
							<div id="step2">
								<el-collapse-item name="4">
									<template slot="title">
										<img src='../../assets/images/team.png' style="width: 22px;height: 18px;"
											alt=""><span style="margin-left: 8px;">我的组织</span>
									</template>
									<div class="collapse-inner">
										<p @click="goto(`/userCenter/pthd/myUnion`)" class="leftfont"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
											新建和管理企业
										</p>
										<p @click="goto(`/userCenter/pthd/myTeam`)" class="leftfont"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
											新建和管理小组
										</p>
									</div>

								</el-collapse-item>
								<el-collapse-item name="5">
									<template slot="title">
										<img src='../../assets/images/setting.png' style="width: 19px;height: 19px;"
											alt=""><span style="margin-left: 8px;">个人设置</span>
									</template>
									<div class="collapse-inner">
										<p @click="goto(`/userCenter/Identification`)" class="leftfont"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
											身份认证
										</p>
										<p @click="goto(`/userCenter/mySubscriptions`)"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
											我的订阅
										</p>
										<p @click="goto(`/userCenter/permissionSet`)"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
											权限设置
										</p>
										<p @click="goto(`/userCenter/accountSet`)"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;margin: 15px;cursor: pointer;font-size: 16px;">
											账号设置
										</p>
									</div>

								</el-collapse-item>
							</div>

						</el-collapse>
					</div>

				</div>
			</div>
			<div style="flex: 1;">
				<router-view></router-view>
			</div>


		</div>

	</div>
</template>

<script>
	const cityOptions = ['个人简历', '资质荣誉'];
	const cityOptions2 = ['项目需求', '资源工具', '解决方案', '产品服务', '求助应助'];
	const cityOptions3 = ['站内信', '系统客服'];
	const cityOptions4 = ['新建和管理企业', '新建和管理小组'];
	const cityOptions5 = ['身份认证', '我的订阅', '权限设置', '账号设置'];
	export default {

		data() {
			return {
				qiehuanDialogVisible: false,
				qiehuanDialogVisible1: false,
				activeNames: ['1', '2', '3', '4', '5'],
				companies: [],
				companies1: [],
				companiesValue: '',
				companiesValue1: '',
				//对话框1
				notReadMsg: '',
				timer: null
			}
		},
		created() {
			this.getCompany()
			this.getGroup()
			this.$store.dispatch('getNotReadMsg')
			// this.getNotReadMsg()
		},
		mounted() {
			this.timer = setInterval(() => {
				this.$store.dispatch('getNotReadMsg')
			}, 15000)
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		methods: {
			isReadHandler(){
				console.log(123123123123123);
				this.getNotReadMsg()
			},
			async getNotReadMsg() {
				const notread = await this.$api.getNotReadMsg()
				this.notReadMsg = notread.data
			},
			changeRole() {
				if (this.companiesValue == '') return
				let info = this.companies.find(item => item.id == this.companiesValue)
				this.$store.commit('SET_CompanyInfo', info)
				sessionStorage.setItem('companyInfo', JSON.stringify(info));
				this.qiehuanDialogVisible = false
				this.$router.push(`/companyCenter`)
			},
			changeRole1() {
				if (this.companiesValue1 == '') return
				let info = this.companies1.find(item => item.id == this.companiesValue1)
				this.$store.commit('SET_GroupInfo', info)
				sessionStorage.setItem('groupInfo', JSON.stringify(info));
				this.qiehuanDialogVisible1 = false
				this.$router.push(`/SmallGroup`)
			},
			async getCompany() {
				const list = await this.$api.getMyCompanyList({
					page_size: 9999
				})
				this.companies = list.data.data
			},
			async getGroup() {
				const list = await this.$api.getMyGroupList({
					page_size: 9999
				})
				this.companies1 = list.data.data
			},
			goto(url) {
				this.$router.push(url)
			},
			onSubmit() {
				console.log('submit!');
			},

			gotologin() {
				this.$router.push({
					path: '/login'
				})
			},
			handleChange(val) {
				console.log(val);
			},
			cc(row, column, cell, event) {
				console.log(row, column.label, cell, event);
			},
			//新手引导

		}
	}
</script>
<style>
	.el-form-item__label {
		color: black;
		font-size: 18px;
	}

	.my-button-class {
		background: #0052D9;
		color: white;
		height: 30px;
		width: 80px;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
	}

	.hasBorder {
		border: 1px solid #D2D2D2;
		width: 100%;
	}

	.zhezhaoNeo {
		position: absolute;
		background: transparent;
		width: 1100px;
		height: 330px;
		z-index: 999;
		left: 0;
		top: 20px;
	}

	.zhezhaoThree {
		position: absolute;
		background: transparent;
		width: 900px;
		height: 100px;
		z-index: 999;
		right: 300px;
		top: -100px;
	}

	.introjs-skipbutton {
		display: none !important;
	}
</style>
<style scoped lang="less">
	.collapse-inner {
		&>p:hover {
			color: #0052D9;
		}
	}

	/deep/.company {
		display: flex;
		justify-content: center;
		padding: 20px;

		.el-input__inner {
			font-size: 18px;
			box-sizing: border-box;
			width: 400px;
			border: 1px solid #D2D2D2;
			border-radius: 6px;
		}
	}

	/deep/.el-dialog__footer {
		padding-top: 0;
	}

	.leimu {
		cursor: pointer;
		text-align: center;
		width: 100px;
		height: 40px;
		border: 1px solid #D2D2D2;
	}

	.main-iteml {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
		margin: 13px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
	}

	.main-item-pic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;

	}

	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}

	.body-mid-main {
		display: flex;
		flex-wrap: wrap;

		justify-content: space-around;
	}


	.body-person-item {
		width: 151px;
		height: 270px;
		background: url('../../assets/images/personBg.png') no-repeat;
		background-position: center bottom;
		background-size: contain;

		& p {
			margin-top: 6px;
			font-size: 18px;
		}
	}

	.body-person {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: center;
	}

	.page-last-body {
		padding: 40px 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.page-last-top {
		display: flex;
		justify-content: space-between;
	}

	.huanyih {
		font-size: 18px;
		width: 110px;
		height: 40px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		text-align: center;
		cursor: pointer;
		line-height: 40px;
		margin-right: 20px;
	}

	.page-last-title {

		width: 120px;
		height: 40px;
		background: #0052D9;
		border-radius: 0px 20px 20px 0px;
		color: white;
		font-size: 22px;
		font-family: PingFang;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}

	.page-last {

		width: 100%;
		height: 450px;
		background: #FFFFFF;
	}

	/deep/.selects {
		margin-left: 15px;

		.el-input__inner {
			color: black;
			width: 100%;
		}

		.el-input__inner::placeholder {
			color: black;
		}

		color: black;
		width:95px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #D2D2D2;
	}

	.body {
		padding: 15px;
		box-sizing: border-box;
		width: 100%;

		.body-item {
			margin-top: 15px;
			display: flex;
			align-items: center;

			.kaitou {
				width: 40px;
				height: 40px;
				background: #EEEEEE;
				font-size: 24px;
				text-align: center;
				line-height: 40px;
			}
		}
	}

	.form {
		box-sizing: border-box;
		width: 100%;

		.main {
			margin: 20px 0;
			display: flex;
			flex-wrap: wrap;

			.main-item {
				cursor: pointer;
				margin-left: 15px;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 140px;
				height: 44px;
				border: 1px solid #D2D2D2;

				img {
					margin-right: 8px;
				}
			}
		}

		.inp {
			align-items: center;
			display: flex;
			font-size: 18px;
			font-family: PingFang;
			font-weight: 500;

			span {
				width: 72px;
				color: #222222;
			}

			input {
				font-size: 18px;

				flex: 1;
				margin-left: 15px;
				box-sizing: border-box;
				padding-left: 10px;
				width: 500px;
				height: 47px;
				background: #F6F6F6;
			}
		}
	}

	/deep/ .introjs-skipbutton {
		display: none;
	}

	/deep/.el-dialog__title {
		font-size: 20px;
		font-weight: bold;
	}



	/deep/ .el-select__caret {
		color: black !important;
	}

	/deep/#selectInp::placeholder {
		color: black !important;
	}

	/deep/.el-input__inner {
		border: none;
		// width: 120px;
	}

	/deep/.el-checkbox {
		display: inline;
		color: #222222;


	}

	.el-dropdown-link {
		cursor: pointer;
		color: black;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}



	.pointer {
		p {
			cursor: pointer;
			margin-bottom: 3px;
		}

		p:hover {
			color: #0052D9;
		}
	}

	.loading {
		cursor: pointer;
		width: 116px;
		height: 40px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		margin: 10px;
		margin-bottom: 0;
		justify-content: center;
	}

	.body-title {
		color: #0052D9;
		display: flex;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;

		.line {
			width: 4px;
			height: 22px;
			background: #0052D9;
		}
	}



	// is-leaf el-table__cell
	/deep/.el-table__cell {
		text-align: center;
		color: #222222;
	}

	/deep/.el-table th.el-table__cell.is-leaf {
		background: #E5EDFB;
		color: #222222;
		border: 1px solid white;
		border-top: none;
	}



	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}

	.body-left-item-foot {
		border-top: 1px solid #EEEEEE;
		display: flex;
		justify-content: space-between;
		padding: 15px;
	}

	/deep/.el-icon-arrow-right:before {
		background: white;
		border-radius: 50%;
		color: #0052D9;
	}

	.collapse-inner {
		padding: 10px;
	}

	.checkbox-wrap {
		display: flex;
		justify-content: space-around;
	}

	/deep/.el-checkbox {
		color: #222222;
		display: inline-block;
		position: relative;
	}

	.body-left {
		width: 260px;

	}

	.body-left/deep/.el-collapse-item__header {
		background: #0052D9;
		height: 55px;
		font-size: 18px;
		color: white;
		padding: 0 20px;
	}

	.left {
		.left-top-user {
			.qiehuan {
				margin: 0 auto;
				margin-top: 15px;
				width: 210px;
				height: 46px;
				background: #E5EDFB;
				color: #0052D9;
				text-align: center;
				cursor: pointer;
				line-height: 46px;
			}

			width: 260px;
			height: 261px;
			background: #FFFFFF;
			padding: 30px 25px;
			box-sizing: border-box;
			margin-bottom: 15px;

			.toux {
				display: flex;
				justify-content: center;

				&>div {
					width: 106px;
					height: 106px;
					overflow: hidden;
					border-radius: 50%;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}

	.wrap {
		position: relative;
		display: flex;
		padding-top: 20px;
		box-sizing: border-box;
	}
</style>